import {
  FacebookShareButton,
  OKShareButton,
  TelegramShareButton,
  TwitterShareButton,
  VKShareButton,
} from 'react-share';
import { Socials } from './types';
import Vk from '../ui/assets/vk_logo.svg';
import Ok from '../ui/assets/ok_logo.svg';
import Fb from '../ui/assets/facebook_logo.svg';
import Tw from '../ui/assets/twitter_logo.svg';
import Tg from '../ui/assets/telegram_logo.svg';

export const sharedButtonsScheme = (
  description: string,
  shareImage: string,
) => [
  {
    id: Socials.TG,
    ButtonComponent: TelegramShareButton,
    Icon: Tg,
  },
  {
    id: Socials.VK,
    ButtonComponent: VKShareButton,
    Icon: Vk,
    additionalProps: { image: shareImage },
  },
  {
    id: Socials.OK,
    ButtonComponent: OKShareButton,
    Icon: Ok,
    additionalProps: { image: shareImage, description },
  },
  {
    id: Socials.FB,
    ButtonComponent: FacebookShareButton,
    Icon: Fb,
  },
  {
    id: Socials.TW,
    ButtonComponent: TwitterShareButton,
    Icon: Tw,
    additionalProps: { hashtags: ['sushiwok'] },
  },
];
